import React from 'react'
import './note.less'

export default (props) => {
  const { data = {}, index } = props
  return <div
    key={index}
    className="note-wrapper"
    style={{
      // inset: `${data.ymin * 100 }% ${100 - data.xmax * 100}% ${100 - data.ymax * 100}% ${data.xmin * 100}%`,360不支持
      top: `${data.ymin}px`,
      right: `${400 - data.xmax}px`,
      bottom: `${473 - data.ymax}px`,
      left: `${data.xmin}px`,
      zIndex: index + 10
    }}
  >
    <div className="index">{index}</div>
  </div>
}
